import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ModalMessage, LoadingSpinner, ProfileForm } from "../../components";
import { getStorageToken, updateStorageUser, useLogout } from "../../utilities";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserApi, updateUserApi } from "../../api/usersApi.js";
import { setUser } from "../../redux/userSlice.js";

export default function EditProfile() {
  // Edit Profile Form with validation (formik + Yup libraries)
  // state of input field is stored in Formik's 'value' object
  // handleChange is supplied by Formik, updates the state (values)

  const logout = useLogout();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const [profileData, setProfileData] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showAlertMsg, setShowAlertMsg] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();

    const fetchData = async () => {
      // returns json
      setIsLoading(true);
      try {
        const token = getStorageToken(user.stayLoggedIn);
        const res = await fetchUserApi(user.id, token, abortController.signal);
        return res;
      } catch (error) {
        if (error?.status === 401) {
          //unautorized, eg token expired
          logout();
        }
        setErrorMsg("Could not load data. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData()
      .then((res) => setProfileData(res))
      .catch((error) => {
        setErrorMsg("Could not load data. Please try again later.");
      });
    return () => {
      abortController.abort();
    };
  }, [user?.id, user?.stayLoggedIn, logout]);

  const handleSubmitClick = async (values) => {
    // update store and storage data
    try {
      const token = getStorageToken(user.stayLoggedIn);
      const abortController = new AbortController();
      const res = await updateUserApi(
        user.id,
        values,
        token,
        abortController.signal
      );
      dispatch(
        setUser({
          ...user,
          firstName: res.firstName,
          lastName: res.lastName,
          email: res.email,
        })
      );
      updateStorageUser({
        firstName: res.firstName,
        lastName: res.lastName,
        email: res.email,
      });
      navigate("/user");
    } catch (error) {
      if (error?.status === 401) {
        //unautorized, eg token expired
        logout();
      } else if (error?.status === 403 || error?.status === 409) {
        //403 = incorrect password, 409 = email taken
        setErrorMsg(
          error?.message || "Incorrect password or email already in use."
        );
      } else {
        setErrorMsg("Could not load data. Please try again later.");
      }
    }
  };

  const handleConfirm = () => {
      navigate("/user");
  };

  return (
    <Container>
      {errorMsg && (
        <ModalMessage
          type="danger"
          message={errorMsg}
          setErrorMsg={setErrorMsg}
        />
      )}
      <Row className="mt-5 justify-content-md-center">
        <Col lg={6} className="p-4">
          <h1>Edit Profile</h1>
          {isLoading ? <LoadingSpinner /> : null}
          {profileData && (
            <ProfileForm
              profileData={profileData}
              setProfileData={setProfileData}
              handleSubmitClick={handleSubmitClick}
              handleCancel={() => setShowAlertMsg(true)}
            />
          )}
        </Col>
      </Row>
      {/* alert message */}
      {showAlertMsg && (
        <ModalMessage
          message= "Are you sure you want to leave this page? Your changes have not been saved, yet."
          // setErrorMsg={setShowLogoutMsg}
          confirmButton={true}
          handleConfirm={handleConfirm}
          setShowAlertMsg={setShowAlertMsg}
        />
      )}
    </Container>
  );
}
